module.exports = __webpack_public_path__ + "img/conference2013.7eb71932.png";